import { render } from "./SearchMask.vue?vue&type=template&id=5d012a28"
import script from "./SearchMask.vue?vue&type=script&lang=ts"
export * from "./SearchMask.vue?vue&type=script&lang=ts"
script.render = render

export default script